// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","title":"Gbde836 G9fa6b0 G81a5ae Gd6846a"};